<template>
  <div>
    <b-card header="Anmeldebestätigung:">
      <p class="card-text">
        Sie haben momentan {{ pupilCount }} Kinder aus {{ groupCount }} Klassenstufen
        (Kinder aus Klassenstufe 1 und 2 zählen zur Klassenstufe 3) angemeldet. Bei einer
        Teilnahmegebühr von <strong>{{ competition.costs.price }} {{ competition.costs.currency }}</strong>
        pro Kind ergibt das einen Gesamtbetrag von <strong>{{ total }} {{ competition.costs.currency }}</strong>.
      </p>
      <p>
        Bis zum Anmeldeschluss am {{ competition.getRegistrationEnd() | moment('LL') }} können Sie noch Kinder an- und abmelden und sich bezüglich der
        Wettbewerbsform umentscheiden. Die Teilnehmerzahl, die am Ende des {{ competition.getRegistrationEnd() | moment('L') }} eingetragen
        ist, ist verbindlich. Den entsprechenden Gesamtbetrag überweisen Sie bitte bis zum {{ competition.getPaymentDate() | moment('LL') }}
        (Eingang auf unserem Konto) auf unten stehendes Konto. Bitte geben Sie im Betreff Namen und Ort Ihrer Schule an, damit wir die Zahlung
        zuordnen können. Es sind keine Rückzahlungen für nicht anwesende Schüler*innen möglich, es erhalten aber alle angemeldeten Schüler*innen
        einen Teilnahmepreis. Sie können während der Wettbewerbswochen noch in begrenztem Rahmen (10%) Schüler*innen nachmelden. In diesem Fall
        überweisen Sie die fehlenden Teilnahmegebühren direkt im Anschluss an den Wettbewerb.
      </p>
      <p>
        Wenn Sie eine Rechnung benötigen, finden Sie diese in Ihrem Account unter „Überblick“ nach einem Klick auf "{{ competition.title() }}".
      </p>
      <p>
        Unsere Kontodaten:
      </p>
      <p>
        makiri GmbH<br/>
        GLS Bank<br/>
        IBAN: DE08 4306 0967 1159 1563 00<br/>
        BIC: GENODEM1GLS
      </p>

      <b-form-checkbox v-model=confirmed>Ich habe die Bedingungen gelesen und akzeptiert</b-form-checkbox>
    </b-card>

    <b-row class="mt-5">
      <b-col>
        <b-button type="button" variant="secondary" v-on:click="$emit('back')">zurück</b-button>
      </b-col>

      <b-col class="text-right">
        <b-button type="button" variant="primary" :disabled="!confirmed" v-on:click="$emit('send')">
          absenden
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import InvoiceAddress from '@/components/competitions/registration/Invoice'

export default {
  name: 'CompetitionRegistrationConfirmation',
  props: ['competition', 'classes', 'invoiceRequired', 'invoiceAddress'],
  components: {
    InvoiceAddress
  },

  data: function () {
    return {
      confirmed: false
    }
  },

  computed: {
    pupilCount: function () {
      let count = 0
      this.classes.each(registeredClass => {
        count += registeredClass.count
      })

      return count
    },

    groupCount: function () {
      return this.classes.length
    },

    total: function () {
      return this.pupilCount * this.competition.costs.price
    }
  },

  methods: {
    onInvoiceRequired: function (value) {
      this.$emit('invoiceRequired', value)
    },

    onInvoiceAddress: function (value) {
      this.$emit('invoiceAddress', value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/competitions/registration/Confirm.vue